import { Link } from "gatsby";
import * as React from "react";
import styled from "styled-components";
import {
  WideWrapper,
  WRAPPER_WIDE_MAX_WIDTH,
} from "../../../styles/shared/layout";
import {
  brandBlueDark,
  brandBlueLight,
  closeGreen,
  darkPurple,
  darkPurpleV2,
  ink2,
  lightGreen,
  lightPurple,
  neutralsGrey,
  purple,
  utlityGradient,
  white,
  lightblue2,
  ink3,
} from "../../../styles/shared/colors";
import DownCaratArrow from "../../../assets/icon-colors/mutibrand-icons/icon-carat-down.svg";
import DownloadBlue from "../../../assets/icon-colors/mutibrand-icons/icon-download-blue.svg";
import DownloadGreen from "../../../assets/icon-colors/mutibrand-icons/icon-download-green.svg";
import DownloadPurple from "../../../assets/icon-colors/mutibrand-icons/icon-download-purple.svg";
import DownloadWhite from "../../../assets/icon-colors/mutibrand-icons/icon-download-white.svg";
import HomeIcon from "../../../assets/icon-colors/mutibrand-icons/iconhome.svg";
import MultiBrandNav from "../MultiBrandHeader/MultiBrandNav";

const UtilityWideWrapper = styled.div`
    position: relative;
    z-index: 3;
    background: ${white};
    border-bottom: 2px solid ${neutralsGrey};
    @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
      border: none;
    }
  `;
  const MultiBrandUtilityBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 40px;
    height: 100%;
    align-items: center;
    width: 100%;
  `;
  const MultiBrandDropDownMainWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    height: 100%;
    align-items: center;
    @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
      gap: 0px;
      width: 100%;
      .multibrand-dropdown-wrapper:last-child {
        .multibrand-dropdown-btn {
          border-right: 0px !important;
          justify-content: flex-end;
        }
      }
    }
  `;
  const MultiBrandHomeBtn = styled.div`
    display: flex;
    align-items: center;
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
      cursor: pointer;
      font-size: 12px;
      font-weight: 800;
      line-height: 16px;
      color: ${brandBlueDark};

      &:hover {
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: auto;
        text-decoration-color: ${brandBlueLight};
        text-decoration-thickness: 10.5%; /* 1.26px */
        text-underline-offset: 2px;
        text-underline-position: auto;
      }

      &:focus-visible {
        box-shadow: 0 0 24px 0 ${lightblue2};
        outline: none;
      }

      .homeIcon {
        margin-left: 8px;
      }

       @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
            display: none;
       }
    }
  `;
  const MultiBrandWideWrapper = styled(WideWrapper)`
    @media (min-width: 1024px) {
      padding: 0 20px;
    }
  `;

export default function MultiBrandUtilityBar() {
  
  const [openDropdownIndex, setOpenDropdownIndex] = React.useState(null);

  const handleDropdownToggle = (index) => {
    setOpenDropdownIndex((prev) => (prev === index ? null : index));
  };
  return (
    <UtilityWideWrapper>
      <MultiBrandWideWrapper>
        <MultiBrandUtilityBarWrapper>
          <MultiBrandDropDownMainWrapper>
            <MultiBrandHomeBtn>
              <Link to="/">
                Home
                <img className="homeIcon" src={HomeIcon} alt="home" />
              </Link>
            </MultiBrandHomeBtn>
            <MultiBrandDropDown
              btnText="Prescribing Information"
              index={0}
              linksData={[
                {
                  text: "WELIREG",
                  link: "https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_pi.pdf",
                  type: "welireg",
                  iconType: "download",
                  target: "_blank",
                },
                {
                  text: "KEYTRUDA",
                  link: "https://www.merck.com/product/usa/pi_circulars/k/keytruda/keytruda_pi.pdf",
                  type: "keytruda",
                  iconType: "download",
                  target: "_blank",
                },
                {
                  text: () => (
                    <span>
                      KEYTRUDA <span className="purple">QLEX</span>
                    </span>
                  ),
                  link: "https://www.merck.com/product/usa/pi_circulars/k/keytruda_qlex/keytruda_qlex_pi.pdf",
                  type: "qlex",
                  iconType: "download",
                  target: "_blank",
                },
              ]}
              openDropdownIndex={openDropdownIndex}
              setOpenDropdownIndex={setOpenDropdownIndex}
            />
            <MultiBrandDropDown
              btnText="Medication Guide"
              index={1}
              linksData={[
                {
                  text: "WELIREG",
                  link: "https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_mg.pdf",
                  type: "welireg",
                  iconType: "download",
                  target: "_blank",
                },
                {
                  text: "KEYTRUDA",
                  link: "https://www.merck.com/product/usa/pi_circulars/k/keytruda/keytruda_mg.pdf",
                  type: "keytruda",
                  iconType: "download",
                  target: "_blank",
                },
                {
                  text: () => (
                    <span>
                      KEYTRUDA <span className="purple">QLEX</span>
                    </span>
                  ),
                  link: "https://www.merck.com/product/usa/pi_circulars/k/keytruda_qlex/keytruda_qlex_mg.pdf",
                  type: "qlex",
                  iconType: "download",
                  target: "_blank",
                },
              ]}
              openDropdownIndex={openDropdownIndex}
              setOpenDropdownIndex={setOpenDropdownIndex}
            />
          </MultiBrandDropDownMainWrapper>
          <MultiBrandNav type="utility" />
        </MultiBrandUtilityBarWrapper>
      </MultiBrandWideWrapper>
    </UtilityWideWrapper>
  );
}

const MultiBrandDropDownBtnHover = `
        color: ${brandBlueDark};
       
        border-color: ${neutralsGrey};
        border-bottom-color: transparent;
        box-shadow: inset 3.5px 0 0 0 ${neutralsGrey};
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        position: relative;
        z-index: 2;

        background: ${white};
        // background: linear-gradient(0deg, #F9FBFD 0%, #F9FBFD 100%, #FFF);

        .multibrand-dropdown-icon{
            transform: rotate(180deg);
        }
          //   &::before{
          // content: "";
          // position: absolute;
          // top: calc(100% - 1px);
          // left: 4px;
          // width: calc(100% - 5px);
          // background: rgb(255, 255, 255);
          // height: 2px;
          // z-index: 1;
      // }
        @media(max-width: ${WRAPPER_WIDE_MAX_WIDTH}){
            border-width: 0 2px 0 0;
            border-style: solid;
        }
    `;

const MultiBrandDropDownWrapperActive = `
       
        .multibrand-dropdown-content-wrapper{
            display: flex;
        }
        .multibrand-dropdown-btn{
            ${MultiBrandDropDownBtnHover}
        }
    `;

const MultiBrandDropDownWrapper = styled.div`
  position: relative;
  // @media (hover: hover) {
   
  //   &:hover {
    
  //     ${MultiBrandDropDownWrapperActive}
  //     .multibrand-dropdown-btn{
  //       color: ${ink3};
  //     }
  //   }
    
  // }
  &.active {
    ${MultiBrandDropDownWrapperActive}
  }

   &.notActive{
     .multibrand-dropdown-btn{
     color: ${ink3};
     background: linear-gradient(180deg, #D9E7F4 0%, #FFF 41.38%), #FFF;
     }
  }
  
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    width: 50%;
    &.notActive {
      .multibrand-dropdown-btn {
        background: linear-gradient(0deg, #D9E7F4 2.11%, #FFF 41.4%), #FFF;
      }
    }
  }
`;
const MultiBrandDropDownBtn = styled.button`
  padding: 9px 12px;
  color: ${brandBlueDark};
  font-family: "proxima-nova";
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
  border: none;
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  border-radius: 2px;
  border: 1px solid ${neutralsGrey};
  background: ${utlityGradient};

  

  .multibrand-dropdown-icon {
    width: 10px;
    height: 6px;
    background-image: url(${DownCaratArrow});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  // @media (hover: hover) {
  //   &:hover {
  //     ${MultiBrandDropDownBtnHover}
  //     }
    
  // }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 0;
    background: ${white};
    border-width: 0px 2px;
    border-style: solid;
    border-color: transparent;
    border-bottom: 1px solid ${neutralsGrey};
    border-left: 2px;
    gap:12px;
  }
`;

const MultiBrandDropDownContentWrapper = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  margin-top: -1px;
  z-index: 1;
  left: 0;
  flex-direction: column;
  background: ${white};
  min-width: 484px;
  width: 100%;
  box-shadow: 4px 8px 8px 0 ${purple};
  border-color: ${neutralsGrey};
  border-style: solid;
  border-width: 1px 1px 0 0;
  border-bottom-right-radius: 8px;
  overflow: hidden;

  &.active {
    display: flex;
  }
  .blue-rounded-bottom {
    widht: 100%;
    height: 4px;
    background: ${brandBlueDark};
  }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    position: fixed;
    top: 40px;
    left: 0;
    // box-shadow: 0px 4px 4px 0 ${purple};
    min-width: unset;
    width: 100vw;
  }
`;

const MultiBrandDropDownContentLink = styled(Link)`
  padding: 18.33px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 4px solid transparent;
  font-family: "proxima-nova";
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  text-decoration: none;

  color: ${ink2};
  ${(props) =>
    props.type === "welireg"
      ? `
                color: ${darkPurple};
                border-color: ${brandBlueLight};
                &:hover{
                    border-color: ${brandBlueLight};
                    background: ${brandBlueLight};
                }
                &:active{
                    border-color: ${brandBlueLight};
                    background: ${brandBlueDark};
                }
                ${
                  props.iconType === "download"
                    ? `
                    .drop-down-link-icon {
                        display: inline-block;
                        width: 14px;
                        height: 17px;
                        background-image: url(${DownloadBlue});
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;
                    }
                    `
                    : ``
                }
            `
      : props.type === "keytruda"
        ? `
                color: ${closeGreen};
                border-color: ${lightGreen};
                &:hover{
                    border-color: ${closeGreen};
                    background: ${closeGreen};
                }
                &:active{
                    border-color: ${lightGreen};
                    background: ${closeGreen};
                }
                ${
                  props.iconType === "download"
                    ? `
                    .drop-down-link-icon {
                        display: inline-block;
                        width: 14px;
                        height: 17px;
                        background-image: url(${DownloadGreen});
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;
                    }
                    `
                    : ``
                }
            `
        : props.type === "qlex"
          ? `
                color: ${closeGreen};
                border-color: ${lightPurple};
                .purple{
                    color: ${lightPurple};
                }
                &:hover{
                    background: ${lightPurple};
                    border-color: ${lightPurple};
                     .purple{
                        color: ${white};
                    }
                }
                &:active{
                    background: ${darkPurpleV2};
                    border-color: ${lightPurple};
                     .purple{
                        color: ${white};
                    }
                }
                ${
                  props.iconType === "download"
                    ? `
                    .drop-down-link-icon {
                        display: inline-block;
                        width: 14px;
                        height: 17px;
                        background-image: url(${DownloadPurple});
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center;
                    }
                `
                    : ``
                }
            `
          : ``}
  &:hover, &:active {
    color: ${white};
    .drop-down-link-icon {
      background-image: url(${DownloadWhite});
    }
  }
`;

function MultiBrandDropDown({
  btnText,
  linksData,
  index,
  openDropdownIndex,
  setOpenDropdownIndex,
}) {
  const multiBrandDropDownRef = React.useRef(null);

  const isOpen = openDropdownIndex === index;

  function handleClick(e) {
    if (window.innerWidth <= 1024) {
      // mobile / iPad
      e.stopPropagation();
      setOpenDropdownIndex(isOpen ? null : index);
    }
  }

  React.useEffect(() => {
    function handleClickOutside(event) {
      if (
        multiBrandDropDownRef.current &&
        !multiBrandDropDownRef.current.contains(event.target)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [setOpenDropdownIndex]);

  // Detect hover only for desktop
  const isDesktop = typeof window !== "undefined" && window.innerWidth > 1024;

  return (
    <MultiBrandDropDownWrapper
      className={`multibrand-dropdown-wrapper${openDropdownIndex === null ? "" : isOpen ? " active" : " notActive"}`}
      onMouseEnter={() => isDesktop && setOpenDropdownIndex(index)}
      onMouseLeave={() => isDesktop && setOpenDropdownIndex(null)}
    >
      <MultiBrandDropDownBtn
        className="multibrand-dropdown-btn"
        onClick={handleClick}
        ref={multiBrandDropDownRef}
      >
        {btnText}
        <span className="multibrand-dropdown-icon"></span>
      </MultiBrandDropDownBtn>
      <MultiBrandDropDownContentWrapper className="multibrand-dropdown-content-wrapper">
        {linksData.map((eacnLink, index) => {
          return (
            <MultiBrandDropDownContentLink
              key={`drop-down-link-${index}`}
              to={eacnLink.link}
              type={eacnLink.type}
              iconType={eacnLink.iconType}
              target={eacnLink.target}
            >
              {typeof eacnLink.text === "string"
                ? eacnLink.text
                : eacnLink.text()}
              {eacnLink.iconType && <i className="drop-down-link-icon"></i>}
            </MultiBrandDropDownContentLink>
          );
        })}
        <span className="blue-rounded-bottom"></span>
      </MultiBrandDropDownContentWrapper>
    </MultiBrandDropDownWrapper>
  );
}
 